<template>
  <div v-bind:class="{ dark: isDark, light: !isDark, container: true }">
    <span class="message sans">{{message}}</span>
  </div>
</template>

<script>
export default {
  props: ['message', 'isDark']
}
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  padding-bottom: 45px;
  .message {
    font-size: 35px;
    font-weight: bold;
    padding-bottom: 16px;
  }
}
.dark {
  background-color: #262728;
  color: #c9cdd2;
  .message {
    border-bottom: 4px solid #c9cdd2;
  }
}
.light {
  background-color: #ecedf2;
  color: #262728;
  .message {
    border-bottom: 4px solid #262728;
  }
}

@media screen and (max-width: 640px) {
  .container {
  position: relative;
  padding-bottom: 35px;
  .message {
    font-size: 25px;
    padding-bottom: 10px;
  }
}
}
</style>


